import React from "react";
import AppRouter from "./routes/AppRouter";
import { ThemeProviderComponent } from "./context/ThemeProvider";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import "./App.css"
function App() {
  return (
    <ThemeProviderComponent>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppRouter />
        </PersistGate>
      </Provider>
    </ThemeProviderComponent>
  );
}

export default App;
